import { SearchBaseModel } from '../commonModels';

export class TyreSearchModel extends SearchBaseModel {
  public TyreId: number;
  public Name: string;
  public BrandId: number;
  public TyreSegmentId: number;
  public SeasonId: number;
  public TyreCarTypeId: number;
  public Width: number;
  public Height: number;
  public Diameter: number;
  public IsActive: boolean;
  public ResultLimit: number;
  public Tread: string;
  public GarageId: number;
  public CustomerId: number;
  public IsOnPriceList: boolean;
  public Code: string;
  public TyreConstructionTypeId: number;
  public TyreSpeedIndexId: number;
  public TyreLoadIndexId: number;
  public TyreReinforcementId: number;
  public IsAddNewTyreBaseOnSearch: boolean;
  public HasTyreSupplierOffer: boolean;

    constructor() {
      super();
      this.TyreId = null;
      this.Name = null;
      this.BrandId = null;
      this.TyreSegmentId = null;
      this.SeasonId = null;
      this.TyreCarTypeId = null;
      this.Width = null;
      this.Height = null;
      this.Diameter = null;
      this.IsActive = null;
      this.ResultLimit = null;
      this.Tread = null;
      this.GarageId = null;
      this.CustomerId = null;
      this.Code = null;
      this.IsOnPriceList = false;
      this.TyreConstructionTypeId = null;
      this.TyreSpeedIndexId = null;
      this.TyreLoadIndexId = null;
      this.TyreReinforcementId = null;
      this.IsAddNewTyreBaseOnSearch = false;
    }
}
